import { render, staticRenderFns } from "./DeleteIconButton.vue?vue&type=template&id=0ef30beb&scoped=true"
import script from "./DeleteIconButton.vue?vue&type=script&lang=js"
export * from "./DeleteIconButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteIconButton.vue?vue&type=style&index=0&id=0ef30beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef30beb",
  null
  
)

export default component.exports